import { useState, useRef, useEffect } from "react";
import { FaGlobe } from "react-icons/fa";
import { FiCheck } from "react-icons/fi";
import { useTranslation } from "react-i18next";

export default function LanguageDropDown() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const dir = i18n.dir();

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prevState) => !prevState);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const selectLanguage = (selectedLang: "en" | "ar") => {
    i18n.changeLanguage(selectedLang);
    document.documentElement.dir = selectedLang === "ar" ? "rtl" : "ltr";
    setIsOpen(false);
  };

  return (
    <div ref={buttonRef} className="relative hidden lg:block">
      <button
        onClick={toggleDropdown}
        className="group relative rounded-full p-2 duration-300 hover:bg-black/10"
      >
        <FaGlobe className="text-lg text-white md:text-2xl md:text-gray-600 md:group-hover:text-primary" />
      </button>

      {isOpen && (
        <div
          ref={dropdownRef}
          className={`absolute z-[9999] mt-2 w-[9rem] rounded-lg border border-gray-200 bg-white shadow-lg ${dir === "rtl" ? "left-0" : "right-0"}`}
        >
          <ul>
            <li
              onClick={() => selectLanguage("en")}
              className="flex cursor-pointer items-center gap-2 p-3 hover:bg-gray-100"
            >
              <span>English</span>
              {lang === "en" && (
                <FiCheck className={`${dir === "rtl" ? "ml-auto" : "mr-auto"} text-green-500`} />
              )}
            </li>
            <li
              onClick={() => selectLanguage("ar")}
              className="flex cursor-pointer items-center gap-2 p-3 hover:bg-gray-100"
            >
              <span>العربية</span>
              {lang === "ar" && (
                <FiCheck className={`${dir === "rtl" ? "ml-auto" : "mr-auto"} text-green-500`} />
              )}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
